<template>
  <MKBTable show-result elevation="0" />
</template>

<script>
import MKBTable from '@/components/dict/mkb10/MKBTable'

export default {
  name: 'ReferencesMKB10',
  components: { MKBTable },
}
</script>
